import ActivityBar from './activityBar';
import AppBar from './appBar/index.js';
import Statusbar from './statusbar';
import View from './view';
import Views from './views/index.js';
import KeyboardShortcuts from './keyboardShortcuts';
import Layout from './layout';
import ContentTabs from './contentTabs';
import PanelTabs, { panelContainers } from './panelTabs';
import panelLayout from './panelLayout/index.js';
import { Profile } from '@punica/editor';
import Markdown from './markdown/index.js';

const PanelLayout = { manager: panelLayout };
// Slot → tabbed-container registry (bottom horizontal + right vertical). The
// bottom container is the same object as `PanelTabs` (back-compat).
const PanelContainers = panelContainers;

// Named exports for individual shell modules
export {
  ActivityBar,
  AppBar,
  Statusbar,
  View,
  Views,
  KeyboardShortcuts,
  Layout,
  ContentTabs,
  PanelTabs,
  PanelContainers,
  PanelLayout,
  Profile,
  Markdown
};

// Aggregate shell surface used by the global punica object
const shell = {
  ActivityBar,
  AppBar,
  Statusbar,
  View,
  Views,
  KeyboardShortcuts,
  Layout,
  ContentTabs,
  PanelTabs,
  PanelContainers,
  PanelLayout,
  Profile,
  Markdown
};

// Note: Bootstrap is now handled by ModuleRegistry and individual module implementations
// See src/impl/shell/modules/ for module lifecycle management

export default shell;
